import dynamic from 'next/dynamic';
import Head from 'next/head'

const Layout = dynamic(() => import('../components/layout'));

export default function CancellationPolicy() {
  return (
    <Layout>
      <Head>
        <title>Careers | Soluna London</title>
        <meta
          name="description"
          content="Join the team and build your career at Soluna London. Call 0333 016 3500"
        />
        <link rel="canonical" href={`https://solunalondon.com/careers/`} />
        <link
          rel="alternate"
          hrefLang="en-GB"
          href={`https://solunalondon.com/careers/`}
        />
        <link
          rel="alternate"
          hrefLang="en"
          href={`https://solunalondon.com/careers/`}
        />
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`https://solunalondon.com/careers/`}
        />
      </Head>
      <section className="my-16 md:my-16 max-w-4xl px-4 sm:mt-24 sm:px-6 text-gray-700 text-lg lg:max-w-7xl lg:mx-auto lg:px-8 lg:pr-64">
        <h1 className="font-serif">
          <span className="mt-1 block text-4xl font-medium sm:text-5xl xl:text-6xl capitalize">
            <span className="block text-gray-900">
              Careers at <span className="text-brand-600">Soluna London</span>
            </span>
          </span>
        </h1>

        <div className="w-full lg:w-10/12 md:px-8 lg:pl-0 mt-12 space-y-6">
          <p>
            Soluna London is a growing aesthetic clinic always on the lookout
            to acquire the skills that push and keep us ahead of our competition
          </p>
          <p>
            If you believe in delivering to clients exceptional experiences with
            unparalled results we want to hear from you!
          </p>
          <p>
            If you are a NVQ Level 4 or equivalent qualified therapist, with a
            passion for skin, laser and aesthetic treatments, and are looking
            for the opportunity to develop your skills we offer excellent
            training and progression opportunities.
          </p>
        </div>
        <h3 className='my-8 font-serif text-lg md:text-2xl text-gray-900'>Is this you?</h3>
        <div className="w-full lg:w-10/12 md:px-8 lg:pl-0 mt-12 space-y-6">
          <ul className='list-inside list-disc my-8'>
            <li>
              A passion for skincare and aesthetics with a good working
              knowledge of the beauty/aesthetic industry
            </li>
            <li>
              Very passionate attitude and positive attitude toward clients and
              colleagues
            </li>
            <li>
              Confidence to promote &amp; recommend products and services,
              maximising opportunities for sales and referrals
            </li>
            <li>Beauty NVQ Level 3 (minimum)</li>
            <li>
              Beauty NVQ Level 4 (desirable) and/or Laser Core of Knowledge
            </li>
            <li>
              Ability to work flexibly to suit the hours and needs of the
              business to include evening and weekend working
            </li>
          </ul>
        </div>
        <h3 className='my-8 font-serif text-lg md:text-2xl text-gray-900'>What we offer</h3>
        <div className="w-full lg:w-10/12 md:px-8 lg:pl-0 mt-12 space-y-6">
          <ul className='list-inside list-disc my-8'>
            <li>Generous holiday entitlement</li>
            <li>Fantastic commission scheme</li>
            <li>Outstanding training program</li>
            <li>Free laser and skin treatments</li>
            <li>Clear career path</li>
          </ul>
        </div>
        <h3 className='my-8 font-serif text-lg md:text-2xl text-gray-900'>Interested? Get in touch!</h3>
        <div className="w-full lg:w-10/12 md:px-8 lg:pl-0 mt-12 space-y-6">
          <p>
            If your skills and passion align with what we look for in new
            partners please send an email telling us why to{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="mailto:admin@solunalondon.com"
            >
              admin@solunalondon.com
            </a>{' '}
            attaching your CV.
          </p>
        </div>
      </section>
    </Layout>
  )
}
